module.exports = __webpack_public_path__ + "img/rankings.38eeee6a.png";